import { create } from "zustand";
import { devtools } from "zustand/middleware";
import { auth, profileAPI, accountAPI, kycAPI } from "services";

const universalStore = (set, get) => ({
  accountId: null,
  accounts: null,
  transactionId: null,
  user: null,
  profile: null,
  transactions: null,
  isReminderChanged: false,
  selectedMonth: new Date(),

  // activeComponent:"edit",
  fetchInitialData: async () => {
    try {
      const [user, accounts,
        // profile,
        userBasic] = await Promise.all([
          auth.fetchUser(),
          accountAPI.getAccounts(),
          // profileAPI.getProfile(),
          profileAPI.getProfileBasics()
        ]);

      //Update Global State
      set({ user, accounts, userBasic, selectedMonth: new Date() });
    } catch (error) {
      console.error("Failed to fetch initial data", error);
    }
  },

  write: (obj) => {
    if (typeof obj === 'function') {
      const result = obj(get()); // Get the current state and pass it to the function
      set(result);
      return;
    }

    //Update Global State
    set(state => ({ ...state, ...obj }));
  },
});

const useUniversalStore = create(
  devtools(universalStore, { name: "Universal Store" })
);

export default useUniversalStore;
